var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classIndividualDetails},[_c('gender-icon',{attrs:{"individual":_vm.individual,"is-in-tree":_vm.isInTree}}),_vm._v(" "+_vm._s(_vm.getBirthDeathSummary)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }